// Utilidades propias de sindicato
import React from "react";
import moment from "moment";
import _ from "lodash";
import { CardTitle } from "material-ui/Card";
import MenuItem from "material-ui/MenuItem";
import { MODE_CRU_UPDATE, MODE_CRU_CREATE } from "../actions/ActionConstants";

export default class UtilPC {
	static getHttpStatusCode(APIReturnedCode) {
		return Number(APIReturnedCode.toString().substring(0, 3));
	}

	static menuItemsYears() {
		let anios = [];
		let anioActual = moment().year();
		for (let i = anioActual; i >= 2013; i--) {
			anios.push(<MenuItem value={i} key={i} primaryText={i} />);
		}
		return anios;
	}

	static menuItemsMonths() {
		const MESES = [
			"Enero",
			"Febrero",
			"Marzo",
			"Abril",
			"Mayo",
			"Junio",
			"Julio",
			"Agosto",
			"Septiembre",
			"Octubre",
			"Noviembre",
			"Diciembre"
		];
		let months = [];
		_.map(MESES, (mes, i) => {
			months.push(<MenuItem value={i + 1} key={i + 1} primaryText={mes} />);
		});
		return months;
	}

	static renderCardTitleCRU(modeCRU, screen) {
		return (
			<CardTitle
				title={
					modeCRU === MODE_CRU_UPDATE
						? `Editar ${screen}`
						: modeCRU === MODE_CRU_CREATE ? `Alta de ${screen}` : screen
				}
				subtitle={
					modeCRU === MODE_CRU_UPDATE
						? `Editar ${screen} existente`
						: modeCRU === MODE_CRU_CREATE ? `Agregar ${screen}` : ""
				}
			/>
		);
	}

	static renderSelectFieldItemsArray(itemsArray) {
		return itemsArray.map(itemsArray => (
			<MenuItem
				key={itemsArray.id}
				value={itemsArray.id}
				primaryText={itemsArray.name}
			/>
		));
	}

	static renderSelectFieldItem(itemId, itemText) {
		return <MenuItem key={itemId} value={itemId} primaryText={itemText} />;
	}
}



// WEBPACK FOOTER //
// ./src/common/UtilPC.js